exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".c-radio-group {\n  display: flex; }\n  .c-radio-group .o-radio,\n  .c-radio-group .o-checkbox {\n    margin-right: 1.375rem; }\n    .c-radio-group .o-radio:last-child,\n    .c-radio-group .o-checkbox:last-child {\n      margin-right: 0; }\n", "", {"version":3,"sources":["/tmp/build_3f9f81bc/src/components/RadioGroup/src/components/RadioGroup/RadioGroup.scss"],"names":[],"mappings":"AACA;EACI,cAAa,EAUhB;EAXD;;IAKQ,uBAAsB,EAKzB;IAVL;;MAQY,gBAAe,EAClB","file":"RadioGroup.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.c-radio-group {\n    display: flex;\n\n    .o-radio,\n    .o-checkbox {\n        margin-right: 1.375rem;\n\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"variables/"; @import /"mixins/";","includePaths":["/tmp/build_3f9f81bc/src/scss"]}!./src/components/RadioGroup/RadioGroup.scss
// module id = 667
// module chunks = 0